import { ComponentChildren, FunctionalComponent } from "preact";

import { Text, TextButton } from "@/uikit";

import { ModalControls } from "@/uikit/Modal";

import "./style.css";

export type HelpType = "balance" | "instantLiquidity" | "tston";

type HelpModalProps = {
  controls: ModalControls;
  type: HelpType;
};

const helpContents: Record<
  HelpType,
  {
    heading: string;
    content: ComponentChildren;
    buttonText?: string;
  }
> = {
  balance: {
    heading:
      "Why is the 'Available to stake' amount less than my actual TON balance?",
    content: (
      <>
        To stake TON, you need to pay a small transaction fee of ~$0.1. TON
        network architecture requires you to have an additional ~1.1 TON for
        this operation, which will be returned to your wallet the second after
        the network confirms staking transaction. This amount is deducted from
        your 'Available to stake' amount.
        <br />
        <br />
        Keep in mind that you will also need to have ~1.1 TON to unstake your
        TON.
      </>
    ),
  },

  instantLiquidity: {
    heading: "What is instant liquidity?",
    content: (
      <>
        Instant liquidity indicates how much TON is available for immediate
        unstaking at the moment. If you select Instant Mode and attempt to
        unstake more than the available amount, your transaction might fail,
        requiring you to try again.
        <br />
        <br />
        If you wish to unstake more than what is available in instant liquidity,
        you can either select Best Rate Mode and receive your TON in ~18 hours
        or wait for the instant liquidity to refill.
      </>
    ),
  },
  tston: {
    heading: "What is tsTON?",
    content: (
      <>
        When you stake TON, you receive tsTON tokens, which serve as a receipt
        for your staked TON.
        <br />
        <br />
        tsTON tokens are worth more than TON and increase in value over time as
        the staking pool accumulates rewards and your share grows. You need to
        hold tsTON to unstake your TON. Additionally, you can use tsTON in DeFi
        protocols within TON ecosystem to earn additional rewards.
      </>
    ),
  },
};

export const HelpModal: FunctionalComponent<HelpModalProps> = (
  { controls, type },
) => {
  const contents = helpContents[type];

  return (
    <div class="balance-modal-modal">
      <div className="balance-modal-description gap-vertical">
        <Text variant="h4" weight="semibold">
          {contents.heading}
        </Text>
        <Text muted>{contents.content}</Text>
      </div>
      <div className="balance-modal-buttons">
        <TextButton onClick={controls.close}>
          {contents.buttonText || "Got it"}
        </TextButton>
      </div>
    </div>
  );
};
